
import Vue from "vue";
import TopBotLayout from "@/layout/top-bot-layout/top-bot-layout.vue";
import Header from "./header/index.vue";
import CompletionTable from "./completion-table/index.vue";

export default Vue.extend({
  components: { TopBotLayout, Header, CompletionTable }
});
